module.exports = __webpack_public_path__ + "static/embragues-b996f0953377272d1f113ac721a8f590.png";